import React from 'react';
import { AVAILABLE_MODELS } from '../../../constants/AvailableModels';
import { RoutingMode } from '../../../libs/models/GenAIModels';

interface IModelBarProps {
  routingMode: RoutingMode;
  setRoutingMode: (m: RoutingMode) => void;
  selectedModel: string;
  setSelectedModel: (m: string) => void;
  disableCache: boolean;
  setDisableCache: (v: boolean) => void;
  // Restricts the model chips to a subset of AVAILABLE_MODELS (mirroring the
  // active agent's backend AgentConfig.allowed_tiers) — undefined shows all
  // 4, matching ls-rag's own unrestricted behavior.
  allowedModels?: string[];
}

const ModelBar: React.FC<IModelBarProps> = ({
  routingMode,
  setRoutingMode,
  selectedModel,
  setSelectedModel,
  disableCache,
  setDisableCache,
  allowedModels,
}) => {
  const models = allowedModels ? AVAILABLE_MODELS.filter(m => allowedModels.includes(m.id)) : AVAILABLE_MODELS;
  return (
    <div className="chat-panel__model-bar">
      <span className="chat-model-label">Model</span>
      <button
        type="button"
        className={`model-chip model-chip--auto${routingMode === 'auto' ? ' active' : ''}`}
        onClick={() => setRoutingMode('auto')}
        title="Automatically route to the most cost-optimized model/cache that can answer this query"
      >
        {'Auto'}
      </button>
      {models.map((m) => (
        <button
          key={m.id}
          type="button"
          className={`model-chip${routingMode === 'manual' && selectedModel === m.id ? ' active' : ''}`}
          onClick={() => {
            setSelectedModel(m.id);
            setRoutingMode('manual');
          }}
          title={m.provider}
        >
          {m.label}
        </button>
      ))}
      <label className="chat-disable-cache" title="Skip the response cache and always call the model">
        <input
          type="checkbox"
          checked={disableCache}
          onChange={(e) => setDisableCache(e.target.checked)}
        />
        {'Disable cache'}
      </label>
    </div>
  );
};

export default ModelBar;
